class BogoProgressBar extends HTMLElement {
  constructor() {
    super();
    this.threshold = 2;
  }

  connectedCallback() {
    this.cart = document.querySelector('cart-drawer');
    if (this.cart) {
      // Listen for cart updates
      document.addEventListener('cart:change', () => this.update());
    }
  }

  update() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const quantity = cart.item_count;
        const percentage = Math.min((quantity / this.threshold) * 100, 100);
        const needsItems = Math.max(this.threshold - quantity, 0);

        const progressState = this.querySelector('[data-bogo-progress]');
        const successState = this.querySelector('[data-bogo-success]');
        const fill = this.querySelector('.bogo-progress-bar__fill');
        const message = this.querySelector('.bogo-progress-bar__message');

        if (quantity >= this.threshold) {
          // Success state
          if (progressState) progressState.style.display = 'none';
          if (successState) successState.style.display = 'block';
        } else {
          // Progress state
          if (progressState) progressState.style.display = 'block';
          if (successState) successState.style.display = 'none';
          
          if (fill) fill.style.width = `${percentage}%`;
          if (message) {
            message.textContent = `ADD ${needsItems} ITEM${needsItems > 1 ? 'S' : ''} & GET ONE FREE`;
          }
        }
      });
  }
}

if (!customElements.get('bogo-progress-bar')) {
  customElements.define('bogo-progress-bar', BogoProgressBar);
}